




















































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

@Component({
  components: {},
})
export default class RiwayatAsesmenPerawat extends Vue {
  @Prop() stateAsesmenAwal: object;
  btn = false;

  get stateuser() {
    return userModule.user;
  }
  get poliAnak() {
    return this.stateuser.unit_id == "06" || this.stateuser.unit_id == "2A";
  }

  setImt(setBb, setTb) {
    if (setBb < 1 || setTb < 1) {
      return 0;
    } else {
      const v = Number((setBb / Math.pow(setTb / 100, 2)).toFixed(2));
      let keterangan = "";

      if (this.poliAnak) {
        keterangan = "";
      } else {
        if (v < 18.5) {
          keterangan = "(Underweight)";
        } else if (v >= 18.5 && v <= 25.0) {
          keterangan = "(Normal)";
        } else if (v > 25.0 && v < 30) {
          keterangan = "(Overweight)";
        } else if (v > 30) {
          keterangan = "(Obesitas)";
        }
      }
      return v.toFixed(2) + " " + keterangan;
    }
  }
  copy(v) {
    this.$emit("copyKeluhan", v);
  }

  selectS() {
    this.btn = true;
  }
  unSelectS() {
    this.btn = false;
  }
}
